export default __webpack_public_path__ + "static/schlafen-screens-586dc57effa6c2a7eb4bb6cdb37fc8b2.png";